import { Loader, type LoaderProps } from "./Loader";
import { LoaderIcon } from "./LoaderIcon";

export const PageLoader = (props: Omit<LoaderProps, "children">) => (
  <Loader {...props}>
    <LoaderIcon />
  </Loader>
);
